module.exports = __webpack_public_path__ + "img/global.cc20a7eb.svg";